import { z } from 'zod';

export const GroupSchema = z.object({
	name: z.string().min(1, 'Nome é obrigatório'),
	permissions: z.array(
		z.object({
			action: z.string(),
			subject: z.string(),
		})
	),
});

export const HierarchySchema = z
	.object({
		name: z.string().min(1, 'Nome é obrigatório'),
		description: z.string().optional(),
		farmer: z.string().optional(),
		consultant: z.string().optional(),
		company: z.string().optional(),
		master: z.string().optional(),
	})
	.refine(data => data.farmer || data.consultant || data.company || data.master, {
		message: 'Pelo menos um nível é obrigatório',
		path: ['farmer'],
	});

export const PlanSchema = z
	.object({
		name: z.string().min(1, 'Nome é obrigatório'),
		description: z
			.string()
			.min(1, 'Descrição é obrigatória')
			.max(1000, 'Descrição deve ter no máximo 1000 caracteres'),
		paymentMethods: z
			.array(z.enum(['credit_card', 'boleto', 'pix', 'free']))
			.min(1, 'Método de pagamento é obrigatório'),
		hierarchy: z.string().min(1, 'Hierarquia é obrigatória'),
		isListable: z.string().optional(),
		price: z.string().optional(),
		recurrentPayment: z.string().optional(),
		interval: z.string().optional(),
		intervalCount: z.string().optional(),
		gracePeriod: z.string().optional(),
		notifyUnpayment: z.string().optional(),
		notifyInvoice: z.string().optional(),
		maxInstallments: z.string().optional(),
		maxProps: z.string().min(1, 'Máximo de propriedades é obrigatório'),
		maxSamples: z.string().min(1, 'Máximo de análises é obrigatório'),
		monthlyFloraTokens: z.string().optional(),
		paymentLink: z.string().optional(),
		advantages: z.array(z.string()).optional(),
	})
	.superRefine((data, ctx) => {
		const isFree = data.paymentMethods.includes('free');
		const hasCard = data.paymentMethods.includes('credit_card');

		if (!isFree && !data.price?.trim()) {
			ctx.addIssue({ code: 'custom', message: 'Valor é obrigatório', path: ['price'] });
		}
		if (!isFree && !data.recurrentPayment?.trim()) {
			ctx.addIssue({ code: 'custom', message: 'Pagamento recorrente é obrigatório', path: ['recurrentPayment'] });
		}
		if (!isFree && !data.interval?.trim()) {
			ctx.addIssue({ code: 'custom', message: 'Intervalo é obrigatório', path: ['interval'] });
		}
		if (!isFree && !data.intervalCount?.trim()) {
			ctx.addIssue({ code: 'custom', message: 'Quantidade de intervalos é obrigatória', path: ['intervalCount'] });
		}
		if (!isFree && !data.gracePeriod?.trim()) {
			ctx.addIssue({ code: 'custom', message: 'Dias de inadimplência é obrigatório', path: ['gracePeriod'] });
		}
		if (hasCard && !data.maxInstallments?.trim()) {
			ctx.addIssue({ code: 'custom', message: 'Parcelas máximas é obrigatório', path: ['maxInstallments'] });
		}
	});

export const GROUP_FIELD_LABELS: Record<string, string> = {
	name: 'Nome',
};

export const HIERARCHY_FIELD_LABELS: Record<string, string> = {
	name: 'Nome',
	farmer: 'Níveis',
};

export const PLAN_FIELD_LABELS: Record<string, string> = {
	name: 'Nome',
	description: 'Descrição',
	paymentMethods: 'Método de Pagamento',
	hierarchy: 'Hierarquia',
	price: 'Valor',
	recurrentPayment: 'Pagamento Recorrente',
	interval: 'Intervalo',
	intervalCount: 'Quantidade de Intervalos',
	gracePeriod: 'Dias de Inadimplência',
	maxInstallments: 'Parcelas Máximas',
	maxProps: 'Máximo de Propriedades',
	maxSamples: 'Máximo de Análises',
	monthlyFloraTokens: 'Tokens Mensais para Flora',
};
